import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-pie-chart',
    //templateUrl: './app/controls/components/chart/pie-chart/pie-chart.html'
    templateUrl: './pie-chart.html',
})
export class PieChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/pie-chart/pie-chart-component.ts